// Editorial room scenes for /get-the-look — plain JS so the React page
// (src/data/lookScenes.ts re-exports it with types) and the build's
// prerendered body read the same data.
//
// Every hotspot owns its honest catalogue match. The room photography is
// inspirational, so labels say "similar" rather than claiming the pictured
// object is the exact SKU. `category` is retained as a safe sold-out fallback
// and `productType` lets the build guard catch merchandising drift.
export const LOOK_SCENES = [
  {
    slug: "warm-minimalist-living",
    title: "Warm Minimalist Living Room",
    caption: "Plaster walls, walnut, and a low travertine table — warmth without clutter.",
    image: "/journal/28-hero.webp",
    article: "/ideas/warm-minimalism-guide",
    hotspots: [
      { x: 11, y: 48, label: "Similar walnut cabinet", category: "/category/cabinets", productType: "Cabinets", productHandle: "35-walnut-solid-wood-accent-cabinet-with-two-doors-and-two-drawers" },
      { x: 20, y: 76, label: "Similar sculptural chair", category: "/category/accent-chairs", productType: "Accent Chairs", productHandle: "29-cream-and-light-brown-fabric-and-wood-curved-arm-chair" },
      { x: 49, y: 79, label: "Similar stone coffee table", category: "/category/coffee-tables", productType: "Coffee Tables", productHandle: "42-stone-glass-and-wood-block-coffee-table" },
      { x: 61, y: 61, label: "Similar stone-base lamp", category: "/category/table-lamps", productType: "Table Lamps", productHandle: "20-cream-concrete-urn-table-lamp-with-cream-empire-shade" },
      { x: 80, y: 70, label: "Similar cream sofa", category: "/category/sofas", productType: "Sofas", productHandle: "88-cream-linen-damask-sofa-and-toss-pillows-with-white-legs" },
      { x: 55, y: 89, label: "Similar neutral area rug", category: "/category/area-rugs", productType: "Outdoor Rugs", productHandle: "8-x-10-ivory-and-cream-striped-indoor-outdoor-area-rug" }
    ]
  },
  {
    slug: "japandi-open-living",
    title: "Japandi Open Living",
    caption: "Paper light, pale oak, and low seating that lets the room breathe.",
    image: "/journal/29-hero.webp",
    article: "/ideas/japandi-style-guide",
    hotspots: [
      { x: 50, y: 18, label: "Similar globe pendant", category: "/category/pendant-lights", productType: "Pendants-Hanging Lights", productHandle: "nova-1-light-white-mini-pendant-with-geometric-globe-shade" },
      { x: 17, y: 69, label: "Similar woven lounge chair", category: "/category/accent-chairs", productType: "Accent Chairs", productHandle: "39-copper-and-brown-woven-upholstery-and-solid-wood-arm-chair" },
      { x: 47, y: 73, label: "Similar oak coffee table", category: "/category/coffee-tables", productType: "Coffee Tables", productHandle: "43-oak-solid-wood-oval-coffee-table" },
      { x: 41, y: 66, label: "Similar ceramic vase", category: "/category/vases", productType: "Vases", productHandle: "10-cream-ceramic-table-vase" },
      { x: 56, y: 62, label: "Similar modular sectional", category: "/category/sectionals", productType: "Sectionals", productHandle: "white-linen-blend-modular-l-shaped-five-piece-corner-sectional" },
      { x: 50, y: 86, label: "Similar neutral area rug", category: "/category/area-rugs", productType: "Outdoor Rugs", productHandle: "8-x-10-ivory-and-beige-geometric-indoor-outdoor-area-rug" }
    ]
  },
  {
    slug: "walnut-dining-room",
    title: "Walnut Dining Room",
    caption: "An oval pedestal table softens a room and seats one more than you'd think.",
    image: "/journal/03-hero.webp",
    article: "/ideas/dining-table-size-guide",
    hotspots: [
      { x: 50, y: 60, label: "Similar oval walnut table", category: "/category/dining-tables", productType: "Dining Tables", productHandle: "67-walnut-solid-wood-double-pedestal-base-oval-dining-table" },
      { x: 39, y: 71, label: "Similar upholstered chair", category: "/category/dining-chairs", productType: "Dining Chairs", productHandle: "cream-and-espresso-upholstered-linen-dining-parsons-chair" },
      { x: 50, y: 88, label: "Similar neutral area rug", category: "/category/area-rugs", productType: "Outdoor Rugs", productHandle: "8-x-10-beige-and-cream-striped-indoor-outdoor-area-rug-1" },
      { x: 4,  y: 40, label: "Similar walnut sideboard", category: "/category/sideboards", productType: "Sideboards", productHandle: "39-walnut-wood-sideboard-with-two-doors" }
    ]
  },
  {
    slug: "quiet-bedroom",
    title: "A Quiet Bedroom",
    caption: "A low oak platform bed, layered linen, and nothing competing for attention.",
    image: "/journal/15-hero.webp",
    article: "/ideas/platform-bed-vs-box-spring",
    hotspots: [
      { x: 50, y: 62, label: "Similar oak bed frame", category: "/category/standard-beds", productType: "Standard Beds", productHandle: "oak-wood-queen-bed-frame" },
      { x: 50, y: 47, label: "Shop similar headboards", category: "/category/headboards", productType: "Headboards" },
      { x: 62, y: 62, label: "Similar ivory knit throw", category: "/category/throws-blankets", productType: "Throws & Blankets", productHandle: "ivory-knitted-100-cotton-throw-blanket" },
      { x: 50, y: 90, label: "Similar textured area rug", category: "/category/area-rugs", productType: "Outdoor Rugs", productHandle: "8-x-10-ivory-and-beige-geometric-washable-indoor-outdoor-area-rug" }
    ]
  }
];
